export default __webpack_public_path__ + "static/campaign-management.url-90cc860d52e27688f3d66949ed3d4310.svg";